import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import PublicInsightDetails from './PublicInsightDetails';
import { useTranslation } from 'react-i18next';

const PublicInsightDetailsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Stack direction="column" spacing={3} sx={{ p: 3, flex: 1, display: 'flex' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="title">{t('breadcrumbs.Insight Details', 'Insight Details')}</Typography>
      </Stack>
      <Box sx={{ flex: 1 }}>
        <PublicInsightDetails />
      </Box>
    </Stack>
  );
};

export default PublicInsightDetailsPage;
